export default __webpack_public_path__ + "static/media/filter-divisions.4c4adc77.svg";